/* src/app/shared/components/popup/popup.component.scss */
.tabs {
  width: 100%;
  border-bottom: 2px solid #10069F;
  margin: 0 0 2em 0;
  font-family: "FSAlbertArabic-Bold";
  font-weight: bold;
}
.tabs__item {
  font-size: 12px;
  text-transform: uppercase;
  border-bottom: none;
  position: relative;
  border-left: 1px solid #ffffff;
  cursor: pointer;
  top: 2px;
  padding: 10px 30px;
  background: #10069F;
  color: #ffffff;
}
.tabs__item:first-child {
  border-left: none;
}
.tabs__item.active {
  background-color: #ffffff;
  color: #10069F;
  border: 1px solid #10069F;
  border-bottom: none;
  margin-top: -2px;
}
.tabs__item.active + .tabs__item {
  border-left: none;
}
:host {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: row;
}
.main-container {
  margin: auto;
  display: flex;
  flex-direction: column;
  width: 570px;
  justify-content: center;
}
.popup-body-container {
  position: relative;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  border-top-left-radius: 0px;
  align-items: stretch;
  background-color: #FFFFFF;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
  max-height: 380px;
}
.popup-body-container .popup-collapse {
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 4px;
  cursor: pointer;
}
.tabs {
  margin: 0;
}
/*# sourceMappingURL=popup.component.css.map */
